// extracted by mini-css-extract-plugin
export default {"map-frame":"Nav_kochquartier_map-frame__2yzyc","map":"Nav_kochquartier_map__XB1KP"};